var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"form-login-video-greeting"},[_vm._v(_vm._s(_vm.$tf('hi'))+", "+_vm._s(_vm.realName)+"!")])}
var staticRenderFns = []

export { render, staticRenderFns }